var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      attrs: {
        id: _vm.modalName,
        name: _vm.modalName,
        "modal-props": _vm.compModalProps,
        title: "Время отправки",
      },
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "dateTime" }, [
            _c(
              "div",
              { staticClass: "date" },
              [
                _c("date-picker", {
                  ref: "datePicker",
                  attrs: {
                    type: "date",
                    "first-day-of-week": 1,
                    lang: _vm.lang,
                    "default-value": _vm.schMsgDate,
                    "not-before": _vm.beforeDate,
                    placeholder: _vm.defaultDateStr,
                    editable: false,
                    clearable: false,
                    format: "DD.MM.YY",
                    "input-class": ["date-picker-date"],
                    "popup-style": _vm.popUpStyleDate,
                    width: "140",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "calendar-icon",
                      fn: function () {
                        return [_c("i", { staticClass: "fal fa-calendar" })]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.schMsgDate,
                    callback: function ($$v) {
                      _vm.schMsgDate = $$v
                    },
                    expression: "schMsgDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "time" },
              [
                _c("date-picker", {
                  attrs: {
                    type: "time",
                    lang: _vm.lang,
                    "default-value": _vm.schMsgTime,
                    "not-before": _vm.beforeTime,
                    "input-class": ["date-picker-time"],
                    "minute-step": _vm.minuteStep,
                    placeholder: _vm.defaultTimeStr,
                    editable: false,
                    clearable: false,
                    "date-format": "HH:mm",
                    format: "HH:mm",
                    "popup-style": _vm.popUpStyleTime,
                    confirm: "",
                    "confirm-text": _vm.$t("done"),
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "calendar-icon",
                      fn: function () {
                        return [_c("i", { staticClass: "fal fa-clock" })]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.schMsgTime,
                    callback: function ($$v) {
                      _vm.schMsgTime = $$v
                    },
                    expression: "schMsgTime",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "btn", on: { click: _vm.cancelBtn } }, [
          _vm._v(_vm._s(_vm.$t("cancel"))),
        ]),
        _c("div", { staticClass: "btn", on: { click: _vm.okBtn } }, [
          _vm._v(_vm._s(_vm.$t("apply"))),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }